import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import FilterOption from "./FilterOption";

export function SearchableFilterSelect({
  display = true,
  visible,
  toggle,
  filters,
  searchFilters,
  searchValue = "",
  setFilters,
  right,
  children,
  title = "Filter"
}) {
  const classes = classNames("input-group-btn", { open: visible });
  const menuClasses = classNames("dropdown-menu", {
    "dropdown-menu-right": right
  });

  if (!display) return null;

  return (
    <span className={classes}>
      <button className="btn btn-default dropdown-toggle" onClick={toggle}>
        {title} <i className="fa fa-f2 fa-caret-down" />
      </button>
      {visible && (
        <div
          onClick={toggle}
          style={{
            position: "fixed",
            top: "0px",
            left: "0px",
            backgroundColor: "transparent",
            height: "100vh",
            width: "100vw",
            zIndex: 5
          }}
        />
      )}
      <ul className={menuClasses} style={{ zIndex: 10 }}>
        <li>
          <input
            key="application-search"
            className="form-control"
            onChange={searchFilters}
            value={searchValue}
            autoFocus
            style={{
              paddingRight: "10px",
              paddingLeft: "10px",
              height: "40px"
            }}
          />
        </li>
        {filters.map(filter => (
          <FilterOption
            filter={filter}
            onClick={selectedFilters => {
              setFilters(selectedFilters);
              toggle();
            }}
          />
        ))}
      </ul>
      {children}
    </span>
  );
}

SearchableFilterSelect.propTypes = {
  display: PropTypes.func,
  visible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  right: PropTypes.bool,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      filters: PropTypes.shape(),
      withAuthorization: PropTypes.shape({
        roles: PropTypes.arrayOf(PropTypes.string),
        authorizedIf: PropTypes.func
      })
    }).isRequired
  ).isRequired,
  searchFilters: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  title: PropTypes.string
};

export default SearchableFilterSelect;



// WEBPACK FOOTER //
// ./app/modules/shared/components/FilterSelect/SearchableFilterSelect.jsx